import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const MontoNacionalFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='MONTO NACIONAL' htmlFor='input-modalavanz-montoNacional' md={12} />
      <Col md={12}>
        <Field name='montoNacional'>
          {({ field }) => <Form.InputNumber {...field} id='input-modalavanz-montoNacional' isInvalid={iTouched && iError} disabled={fIsSubmitting} />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MontoNacionalFormGroup)
